import {
  IS_DARK_MODE,
  SATELLITE_IMAGE,
  SHOW_TRAFFIC,
} from "constants/ActionTypes";

const INIT_STATE = {
  isDarkMode: false,
  satelliteImage: false,
  showTraffic: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case IS_DARK_MODE: {
      return {
        ...state,
        isDarkMode: !state.isDarkMode,
        satelliteImage: false,
      };
    }
    case SATELLITE_IMAGE: {
      return {
        ...state,
        satelliteImage: !state.satelliteImage,
      };
    }
    case SHOW_TRAFFIC: {
      return {
        ...state,
        showTraffic: !state.showTraffic,
      };
    }
    default:
      return state;
  }
};
